import { INamespaceActionCreator, IReducer } from '@omaze/redux';
import { AnyAction } from '@reduxjs/toolkit';

import { EMAIL_CAPTURE_ACTION } from '../email-capture-actions';
import { createEmailCaptureActionCreatorFactory, createEmailCaptureReducerFactory } from '../email-capture.factories';
import { ErrorType, IEmailCaptureState, Status } from '../email-capture.state';

export const createValidateEmailCaptureStartAction: INamespaceActionCreator = createEmailCaptureActionCreatorFactory(
    EMAIL_CAPTURE_ACTION.VALIDATE_EMAIL_CAPTURE_START,
    (payload: string): string => {
        return payload;
    },
);

const EMAIL_VALIDATOR: RegExp = /^[a-zA-Z0-9]+([-._][a-zA-Z0-9]+)*@([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*.)+\.+[a-zA-Z]{2,}$/;

export function isEmailValid (email: string): boolean {
    return EMAIL_VALIDATOR.test(email) && email !== '';
}

export const validateEmailCaptureStartReducer: IReducer<IEmailCaptureState> = createEmailCaptureReducerFactory(
    EMAIL_CAPTURE_ACTION.VALIDATE_EMAIL_CAPTURE_START,
    (state: IEmailCaptureState, action:AnyAction): void => {
        if (isEmailValid(action.payload)) {
            state.status = Status.LOADING;
            state.error = ErrorType.INITIAL;
        } else {
            state.status = Status.ERROR;
            state.error = ErrorType.INVALID_EMAIL;
        }
    }
);
